export default __webpack_public_path__ + "static/media/logo.0df1f9c1.svg";